module.exports = __webpack_public_path__ + "static/media/2.4f4bd5f3.jpg";